import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loanAmount:"100000",
  timePeriod:"5",
  intrestRate: "6.5",
  totalAmount: 0,
  edErrors:null

};

const personalLoanSlice = createSlice({
  name: "personalLoanCalculator",
  initialState: initialState,
  reducers: {
    setLoanAmmount: (state, action) => {
      state.loanAmount = action.payload;
    },
    setTimePeriod: (state, action) => {
      state.timePeriod = action.payload;
    },
    setIntrestRate: (state, action) => {
      state.intrestRate = action.payload;
    },
    setPerEmi: (state, action) => { 
      state.perEmi = action.payload;
    },
    setTotalAmount: (state, action) => {
      state.totalAmount = action.payload;
    },
    resetPersonalData: (state) => {
      return initialState;
    },
   
  },
});

 export const { setActiveCalculater} = personalLoanSlice.actions;

export const {
  setLoanAmmount, setTimePeriod, setIntrestRate, setPerEmi,resetPersonalData,setTotalAmount
} = personalLoanSlice.actions;
export default personalLoanSlice.reducer;
